import TableWrapper from '@/features/tablewrapper/TableWrapper';
import { MercuryTableProvider } from '@/features/tablewrapper/MercuryTableContext';
import { basicTableNormalize } from '@/features/tablewrapper/services/tableTransforms';

import { subscriptionsTable } from '../subscriptions/subscriptions.table';
import { settingsKeys } from '../../services/keys';

const TransactionsInfo = () => (
  <MercuryTableProvider
    columns={subscriptionsTable}
    queryKey={settingsKeys.transactions()}
    tableEndpoint={() => () => '/v0/clients/transactions/'}
    dataTransform={basicTableNormalize}
    initialState={{
      order: 'created_on',
      'order-dir': 'desc',
    }}
    navigateMode="replace"
    basic
  >
    <TableWrapper />
  </MercuryTableProvider>
);

export default TransactionsInfo;
